import { get, post, put } from '../store/apiClient';
import { ApplicationResponse } from '../store/slices/task/taskTypes';
import { formatUrl } from '../utils/urlFormatter';

// Endpoint path

const taskListData = '/{0}/task.listCandidateTask';
const meetingDetails = '/{0}/task.meetingDetails';
const applyApplicationQuestionSet = '/{0}/task.questionList';
const updateApplication = '/{0}/task.questionSetUpdate';

const credentialsConfig = {
  withCredentials: true,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};


export const fetchTaskList = async (appId: string): Promise<ApplicationResponse> => {
  const endpoint = formatUrl(taskListData, [appId]);
  return get<ApplicationResponse>(endpoint);
};

export const fetchMeetingDetails = async (typeId: string): Promise<ApplicationResponse> => {
  const endpoint = formatUrl(meetingDetails, [typeId]);
  return get<ApplicationResponse>(endpoint);
};

export const applyApplicationQuestionSetById = async (
  id: string
): Promise<ApplicationResponse> => {
  const endpoint = formatUrl(applyApplicationQuestionSet, [id]);
  return get<ApplicationResponse>(endpoint
  );
};

// Create Application Function
export const createApplicationQuestionTask = async (
  payload: {
    job_id: string;
    base_slug: string;
    app_id: string;
    app_email: string;
    name?: string;
    phone?: string;
    location?: string;
    summary?: string;
    education?: any;
    experience?: any;
    links?: string[];
    resume?: string;
    cover_letter?: string;
  },
  questionId: string
): Promise<ApplicationResponse> => {
  const endpoint = formatUrl(updateApplication, [questionId]);

  return put<ApplicationResponse>(endpoint, payload, { withCredentials: true });
};